import { FILE_BROWSER_TELEMETRY_EVENT_NAME } from './file-browser-telemetry.constants';
export const emitDirectoryLoadedTelemetry = (lucidSdk, { browserInstance, entryCount, filespaceId, loadDurationMs, workspaceId, }) => {
    try {
        lucidSdk.telemetryClient().sendEvent({
            name: FILE_BROWSER_TELEMETRY_EVENT_NAME.DirectoryLoaded,
            data: {
                workspaceId,
                filespaceId,
                customData: { browserInstance, entryCount, loadDurationMs },
            },
        });
    }
    catch { }
};
export const emitDirectorySearchAppliedTelemetry = (lucidSdk, { browserInstance, filespaceId, workspaceId }) => {
    try {
        lucidSdk.telemetryClient().sendEvent({
            name: FILE_BROWSER_TELEMETRY_EVENT_NAME.DirectorySearchApplied,
            data: {
                workspaceId,
                filespaceId,
                customData: { browserInstance },
            },
        });
    }
    catch { }
};
